import SimulationPage from './SimulationPage';

export default SimulationPage;
